<template>
  <div
    class="tw-relative tw-flex tw-w-full tw-flex-col tw-justify-center tw-gap-5 tw-px-4 tw-py-9 tw-text-start"
    :style="`background-color: var(--c-${vars.backgroundColor}); border-radius: var(--rounded); border: 1px solid var(--c-border);`"
  >
    <h4>{{ vars.titleText }}</h4>

    <div v-if="vars.photoImage" class="mb-6">
      <img :src="String(vars.photoImage)" alt="" class="w-full h-auto" />
    </div>
    
    <p class="mb-6" v-if="vars.descriptionText" v-html="String(vars.descriptionText)"></p>
    
    <nuxt-link
      v-if="vars.buttonLinkUrl && vars.cardVersionText !== 'v2'"
      :external="true"
      :to="String(vars.buttonLinkUrl)" 
      :class="`n-${vars.buttonTypeText || 'primary'} n-btn tw-w-fit`"
    >
      {{ vars.buttonLabelText }}
    </nuxt-link>

    <template v-else-if="vars.cardVersionText === 'v2'">
      <nuxt-link :to="String(vars.buttonLinkUrl)" type="button" class="!tw-justify-start tw-w-fit" :class="[vars.buttonTypeText === 'primary' ? '' : 'n-link', `n-${vars.buttonTypeText || 'primary'}`]">
        {{ vars.buttonLabelText }}
        <svg v-if="vars.buttonTypeText !== 'primary'" width="23" height="9" viewBox="0 0 23 9" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M22.3536 4.85355C22.5488 4.65829 22.5488 4.34171 22.3536 4.14645L19.1716 0.964466C18.9763 0.769204 18.6597 0.769204 18.4645 0.964466C18.2692 1.15973 18.2692 1.47631 18.4645 1.67157L21.2929 4.5L18.4645 7.32843C18.2692 7.52369 18.2692 7.84027 18.4645 8.03553C18.6597 8.2308 18.9763 8.2308 19.1716 8.03553L22.3536 4.85355ZM0 4.5V5H22V4.5V4H0V4.5Z" fill="var(--c-primary)"/></svg>
      </nuxt-link>
    </template>
  </div>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'TeamCard',
  mixins: [ComponentMixin],
});
</script>
